export default __webpack_public_path__ + "static/media/star-grey.a8983072.svg";